import { CLAN_CREATE_COST, type Currency, type RewardBundle } from '@vm/shared';

export interface Price {
  price: number;
  currency: Currency;
}

/** The first rename is free; later renames cost gems. */
export const RENAME_PRICE: Price = { price: 200, currency: 'gems' };
/** Creating a clan costs coins (CLAN_CREATE_COST from the API contract). */
export const CLAN_CREATE_PRICE: Price = { price: CLAN_CREATE_COST, currency: 'coins' };

/** Coins and gems a brand new account starts with. */
export const STARTING_WALLET = { coins: 500, gems: 20 } as const;

/** One-time reward for finishing Boot Camp: enough for a first weapon from the Armory. */
export const BOOT_CAMP_REWARD: RewardBundle = { coins: 300 };
